import { ChatThread } from '../../types/chat';

const timestamp = (value?: Date | string | null): number => {
  if (!value) return 0;
  return value instanceof Date ? value.getTime() : new Date(value).getTime();
};

export const sortThreadsForHistory = (threads: ChatThread[]): ChatThread[] =>
  [...threads].sort((a, b) => {
    const aPinned = Boolean(a.isPinned);
    const bPinned = Boolean(b.isPinned);

    if (aPinned !== bPinned) {
      return aPinned ? -1 : 1;
    }

    if (aPinned && bPinned) {
      return timestamp(b.pinnedAt || b.updatedAt) - timestamp(a.pinnedAt || a.updatedAt);
    }

    return timestamp(b.updatedAt) - timestamp(a.updatedAt);
  });
